/**
 * Accessibility helpers.
 */

/**
 * Build an onKeyDown handler that activates a non-native control (an element
 * carrying role="button" + tabIndex={0}) the way a real <button> does: on both
 * Enter and Space.
 *
 * Space is prevented so the page does not scroll, and both keys stop the event
 * from bubbling to an ancestor that may also be activatable.
 *
 * Used instead of wrapping the element in a real <button> where the element
 * already contains its own nested buttons (e.g. the bookmark toggle on content
 * cards) — a button inside a button is invalid HTML and breaks assistive tech.
 *
 * @param {(event: React.KeyboardEvent) => void} handler - invoked on activation
 * @returns {(event: React.KeyboardEvent) => void}
 */
export function activateOnKey(handler) {
  return (event) => {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') {
      return;
    }

    // Let nested controls (bookmark/pin buttons, links) handle their own keys.
    if (event.target !== event.currentTarget) {
      return;
    }

    event.preventDefault();
    handler(event);
  };
}
